import vars from '../../vars';
 
$(document).ready(function() {
	if ($('.b-longrid-autors__item').length > 0) {
		$('.b-longrid-autors__item').each(function() {
			if (($(window).width() >= 1024 && 
				$(this).find('.b-longrid-autors__comment').height() > 550) || 
				($(window).width() < 1024 && 
				$(this).find('.b-longrid-autors__comment').height() > 350)) {
				$(this).addClass('more');
			}
		});
	}
	$(document).on('click', '.js-autor-comment-more', function() {
		$(this).parents('.b-longrid-autors__item').toggleClass('show-comment');
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-autors.js